import React, { useState, Fragment, useEffect, useRef } from 'react'
import styled, { useTheme } from 'styled-components'
import { ReactEditor, useReadOnly, useFocused, useSelected, useSlate } from 'vendor/slate-react'
import { Transforms } from 'vendor/slate'
import { Button, FormControl, FormGroup } from 'react-bootstrap'
import mermaid from 'mermaid'

const Mermaid = props => {
  const theme = useTheme()
  const { setMermaidError } = props

  useEffect(() => {
    mermaid.parseError = function (err, hash) {
      const { str } = err || {}
      setMermaidError(str)
    }

    mermaid.initialize({
      startOnLoad: true,
      flowchart: { useMaxWidth: false, htmlLabels: true },
      theme: theme.id === 'dark' ? 'dark' : 'default'
    })
    mermaid.contentLoaded()
  }, [theme, setMermaidError])

  return (
    <div key={theme.id} className="mermaid">
      {props.chart}
    </div>
  )
}

const MermaidWrapper = ({ attributes, children, element, editor }) => {
  const { chart } = element || {}
  const readOnly = useReadOnly()
  const [key, setKey] = useState(Date.now())
  const [chartInputOpen, setChartInputOpen] = useState(false)
  const [chartValue, setChartValue] = useState(chart)
  const path = ReactEditor.findPath(editor, element)
  const chartData = chart !== chartValue ? chartValue : chart
  const [mermaidError, setMermaidError] = useState(false)

  return (
    <Wrapper>
      <MermaidChartDisplay contentEditable={false}>
        <Mermaid key={key} chart={chartData} setMermaidError={setMermaidError} />
      </MermaidChartDisplay>
      {!readOnly && (
        <MermaidControlsAndChartWrapper contentEditable={false}>
          <MermaidControls>
            <MermaidControlButton
              variant="secondary"
              size="md"
              active={chartInputOpen}
              onClick={() => {
                setChartInputOpen(!chartInputOpen)
              }}
            >
              <i className="fad fa-project-diagram" />
            </MermaidControlButton>
          </MermaidControls>
          <MermaidControlsWrapper>
            {chartInputOpen && (
              <MermaidChart>
                <FormGroup className="mb-3">
                  {mermaidError && <div className="text-start text-danger p-2 pb-3">{mermaidError}</div>}
                  <FormControl
                    size="md"
                    style={{ height: '100px' }}
                    as="textarea"
                    placeholder="Enter mermaid chart code"
                    value={chartValue || ''}
                    onChange={e => {
                      const { value } = e.target
                      if (value.includes('application/x-slate-clipboard:')) {
                        return
                      }
                      setChartValue(value)
                      setKey(Date.now())
                    }}
                  />
                </FormGroup>
                <Button
                  size="md"
                  variant={chart !== chartValue && chartValue && chartValue.length > 0 ? 'primary' : 'secondary'}
                  disabled={chart === chartValue || !chartValue}
                  onClick={() => {
                    Transforms.setNodes(editor, { chart: chartValue }, { at: path })
                  }}
                >
                  Save
                </Button>
              </MermaidChart>
            )}
          </MermaidControlsWrapper>
        </MermaidControlsAndChartWrapper>
      )}
    </Wrapper>
  )
}
export default MermaidWrapper

const Wrapper = styled.div`
  margin: 15px 0px;
`
const MermaidChartDisplay = styled.div`
  padding: 15px 10px;
  text-align: center;
  overflow: auto;
  svg {
    height: auto !important;
  }
`
const MermaidControlsWrapper = styled.div``

const MermaidControlsAndChartWrapper = styled.div`
  margin: 15px 0px 15px 0px;
  width: 100%;
`

const MermaidControls = styled.div`
  justify-content: space-between;
  width: 100%;
  display: flex;
`

const MermaidControlButton = styled(Button)`
  color: ${props => props.theme.textGreyTinted}; !important;
  font-size: 11px;
  font-weight: bold;
`

const MermaidChart = styled.div`
  font-size: 16px;
  color: ${props => props.theme.textGreyTintedLighter};
  margin-top: 15px;
  margin-bottom: 10px;
  width: 100%;
  text-align: right;
  input::placeholder {
    color: ${props => props.theme.textGreyTintedLighter};
  }
`
